import generate from '.'
import formatDate from '@/module/util/format-date'

export default function(analysis) {

    var articles = []

    Object.keys(analysis).forEach((articleId) => {
        let article = analysis[articleId]

        if (article.content) {
            articles.push({
                type: 'row',
                padding: [5, 0],
                size: 10,
                child: [
                    {
                        type: 'column',
                        width: 0.8,
                        child: [
                            {
                                type: 'text',
                                text: article.content.title
                            }
                        ]
                    },
                    {
                        type: 'column',
                        width: 0.2,
                        child: [
                            {
                                type: 'text',
                                text: 'Last read on '
                            },
                            {
                                type: 'text',
                                font: 'ProximaNova-Bold',
                                text: formatDate(article.event[article.event.length - 1].created)
                            }
                        ]
                    }
                ]
            },
            {
                type: 'rectangle',
                height: 0.5,
                color: '#f0f0f0'
            })
        }
    })

    articles.splice(articles.length - 1, 1)

    return {
        child: [
            generate.title('Articles'),
            ...articles
        ]
    }
}
